module.exports = __webpack_public_path__ + "static/media/cargo_boat.69af9e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cargo/cargo_boat.png
// module id = 2156
// module chunks = 0